export const MEMBER_STATUS = ['ACTIVE', 'SUSPENDED', 'BLOCKED'];
